export async function versionCheck(baseUrl: string): Promise<boolean> {
    let shouldMountApp: boolean = true;

    try {
        const currentUrl = new URL(window.location.href);

        if (currentUrl.searchParams.has("logout")) {
            window.history.replaceState({}, document.title, "/");
            return Promise.resolve(shouldMountApp);
        }

        const response = await fetch(`${baseUrl}/GetAppVersion`, { cache: "no-store" });

        if (!response.ok) {
            throw new Error(`HTTP error status: ${response.status} - ${response.statusText}`);
        }

        const serverVersion = (await response.text()).trim();
        let clientVersion = localStorage.getItem("app_version");

        if (!clientVersion) {
            localStorage.setItem("app_version", serverVersion);
            clientVersion = serverVersion;
        }

        const isMatch = serverVersion === clientVersion;

        console.log("%c🚀 VERSION CHECK", "background: #1e1e1e; color: #00e5ff; font-weight: bold; padding: 6px 10px; border-radius: 6px;");
        console.log("%c🌐 Server:%c %c%s", "color: #4caf50; font-weight: bold;", "", "color: #4caf50; font-weight: bold;", serverVersion);
        console.log("%c💻 Client:%c %c%s", "color: #ff9800; font-weight: bold;", "", "color: #ff9800; font-weight: bold;", clientVersion);
        console.log(`%c${isMatch ? "✅ Versions Match" : "❌ Version Mismatch"}`, `color: ${isMatch ? "#4caf50" : "#f44336"}; font-weight: bold; font-size: 13px;`);

        if (!isMatch) {
            console.log("🔄 detected new version");
            localStorage.setItem("app_version", serverVersion);
            window.location.replace(`/?t=${Date.now()}`);
            shouldMountApp = false;
        }

        if (currentUrl.searchParams.has("t")) {
            window.history.replaceState({}, document.title, "/");
        }
    } catch (error) {
        console.error("version check failed:", error);
    }

    return Promise.resolve(shouldMountApp);
}